import {get, post} from '@/lib/fetch.js'


export function TemplateSubmitApi(data) {
    return post('/command/template/add', data)
}

export function TemplateDetailApi(params) {
    return get('/command/template/detail', params)
}

export function TemplateUpdateApi(params) {
    return post('/command/template/update', params)
}

export function TemplateListApi(params) {
    return post('/command/template/list', params)
}

export function TemplateDeleteApi(params) {
    return post('/command/template/delete', params)
}

export function TemplateSwitchStatusApi(params) {
	return post('/command/template/switchstatus', params)
}

export function TemplateAllApi(params) {
    return get('/command/template/all', params)
}


export function OperateSubmitApi(data) {
	return post('/command/operate/add', data)
}

export function OperateListApi(data) {
	return post('/command/operate/list', data)
}

export function OperateUpdateApi(data) {
	return post('/command/operate/update', data)
}
export function OperateAuditStatusUpdateApi(data) {
	return post('/command/operate/audit', data)
}
export function OperateDropApi(data){
	return post('/command/operate/drop', data)
}
export function OperateDeleteApi(data) {
	return post('/command/operate/delete', data)
}

export function OperateDetailApi(data) {
	return get('/command/operate/detail', data)
}

export function ApplyTemplateDetailApi(data){
	return get('/command/apply/template/detail', data)
}

export function ExecuteStatusDetailApi(data) {
	return get('/command/execute/status/detail', data)
}

export function ExecuteStart(data) {
	return post('/command/execute/start', data)
}

export function ExecuteStop(data) {
	return post('/command/execute/stop', data)
}

export function ExecuteServerRetry(data) {
	return post('/command/execute/server/retry', data)
}

export function ExecuteServerStatusDetailApi(data){
        return get('/command/execute/server/status/detail', data)
}
